import { render, staticRenderFns } from "./LaboralDashboardV2.vue?vue&type=template&id=f264977e&"
import script from "./LaboralDashboardV2.vue?vue&type=script&lang=js&"
export * from "./LaboralDashboardV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports